
import {initReactI18next} from 'react-i18next';
import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import i18n from 'i18next';

i18n
  .use(Backend)//パブリックフォルダからの翻訳ファイルをロード
  .use(LanguageDetector)//ブラウザの言語設定をいい感じに取得してくれるプラグイン
  .use(initReactI18next)
  .init({
    fallbackLng: 'ja',
    debug: true,
    react: {
      wait: true,
      useSuspense: false,
    },
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
  });

//初期表示で発火させるための呼び出し
i18n.changeLanguage("ja");

export default i18n;
